<div class="brand-and-currency" [class.large]="large()">
  @if (iconName) {
    <pu-icon class="brand" [size]="20" [iconName]="iconName" />
  } @else {
    <ng-content></ng-content>
  }
  <span class="currency-name" [title]="currency()">{{ currency() }}</span>
</div>
